var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Box, Grid, Tooltip, Typography, useMediaQuery, useTheme, } from "@mui/material";
import React, { useEffect, useState } from "react";
import { CheckCircle, Checks, Circle, Invoice, PaperPlaneTilt, UsersThree, } from "@phosphor-icons/react";
import { useTranslation } from "react-i18next";
import "./ClientSideNavbar.scss";
import ContractApi from "../../../infrastructure/api/pages/contract-api";
export const ClientSideNavBar = ({ page }) => {
    const theme = useTheme();
    const mediumScreen = useMediaQuery(theme.breakpoints.down("md"));
    const { t: translate } = useTranslation();
    const [activeOrder, setActiveOrder] = useState(undefined);
    const urlParams = new URLSearchParams(window.location.search);
    const contractId = urlParams.get("contractId");
    const [responsiblePerson, setResponsiblePerson] = useState();
    const defaultUserData = {
        id: "",
        firstName: "",
        lastName: "",
        email: "",
        phoneNumber: "",
        password: "",
        isDeleted: false,
        locale: "",
        roles: [],
    };
    const pagesArray = [
        { title: "roof-access", order: 1 },
        { title: "billing-address", order: 2 },
        { title: "checking-and-paying", order: 3 },
        { title: "completion", order: 4 },
        // Add more items as needed
    ];
    const getOrderNumber = (page) => {
        const foundItem = pagesArray.find((item) => item.title === page);
        return foundItem ? foundItem.order : undefined;
    };
    useEffect(() => {
        setActiveOrder(getOrderNumber(page));
    }, [page]);
    useEffect(() => {
        getData();
    }, [contractId]);
    const getData = () => __awaiter(void 0, void 0, void 0, function* () {
        try {
            if (contractId) {
                yield ContractApi.getResponsiblePersonByContractId(contractId).then((response) => {
                    setResponsiblePerson(response.data);
                });
            }
        }
        catch (error) {
            console.error("Error while fetching responsible persons:", error);
        }
    });
    return (_jsxs(Grid, { container: true, className: "clientSidebar", size: {
            xs: 12,
            sm: 12,
            md: 3,
            lg: 2.5
        }, sx: {
            gap: { xs: 2, sm: 3, md: 5 },
            "--Grid-parent-columns": 12,
            "--Grid-parent-columnSpacing": "0px"
        }, children: [_jsxs(Grid, { className: "menu", size: {
                    lg: 12
                }, sx: {
                    gap: { xs: 2, sm: 3, md: 5 },
                    flexDirection: { sx: "row", md: "column" },
                    justifyContent: { sx: "space-between", sm: "auto" },
                    width: { xs: "100%", md: "100%", lg: "auto" },
                    marginTop: { sx: "0%", md: "10%" }
                }, children: [_jsxs(Box, { className: page == "roof-access" ? "activemenuitem" : "menuitem", children: [_jsx(Tooltip, { title: "Contactpersonen", children: _jsx(Box, { sx: {
                                        display: "flex",
                                        alignItems: "center"
                                    }, children: activeOrder && activeOrder > 1 ? (!mediumScreen ? (_jsx(CheckCircle, { size: 24, color: "#66BA78" })) : (_jsx(UsersThree, { size: 24, color: "#66BA78" }))) : !mediumScreen ? (_jsx(Circle, { size: 24 })) : (_jsx(UsersThree, { size: 24 })) }) }), !mediumScreen && "Contactpersonen"] }), _jsxs(Box, { className: page == "billing-address" ? "activemenuitem" : "menuitem", children: [_jsx(Tooltip, { title: "Factuurgegevens", children: _jsx(Box, { sx: {
                                        display: "flex",
                                        alignItems: "center"
                                    }, children: activeOrder && activeOrder > 2 ? (!mediumScreen ? (_jsx(CheckCircle, { size: 24, color: "#66BA78" })) : (_jsx(Invoice, { size: 24, color: "#66BA78" }))) : !mediumScreen ? (_jsx(Circle, { size: 24 })) : (_jsx(Invoice, { size: 24 })) }) }), !mediumScreen && "Factuurgegevens"] }), _jsxs(Box, { className: page == "checking-and-paying" ? "activemenuitem" : "menuitem", children: [_jsx(Tooltip, { title: "Controleren en versturen", children: _jsx(Box, { sx: {
                                        display: "flex",
                                        alignItems: "center"
                                    }, children: activeOrder && activeOrder > 3 ? (!mediumScreen ? (_jsx(CheckCircle, { size: 24, color: "#66BA78" })) : (_jsx(PaperPlaneTilt, { size: 24, color: "#66BA78" }))) : !mediumScreen ? (_jsx(Circle, { size: 24 })) : (_jsx(PaperPlaneTilt, { size: 24 })) }) }), !mediumScreen && "Controleren en versturen"] }), _jsxs(Box, { className: page == "completion" ? "activemenuitem" : "menuitem", children: [_jsx(Tooltip, { title: "Afronding...", children: _jsx(Box, { sx: {
                                        display: "flex",
                                        alignItems: "center"
                                    }, children: activeOrder && activeOrder > 4 ? (!mediumScreen ? (_jsx(CheckCircle, { size: 24, color: "#66BA78" })) : (_jsx(Checks, { size: 24, color: "#66BA78" }))) : !mediumScreen ? (_jsx(Circle, { size: 24 })) : (_jsx(Checks, { size: 24 })) }) }), !mediumScreen && "Afronding..."] })] }), _jsx(Grid, { container: true, className: "buttomsidepanel", size: 12, sx: {
                    borderRadius: "24px",
                    display: { xs: "none", md: "inherit" }
                }, children: _jsxs(Grid, { size: 12, sx: {
                        paddingLeft: 1,
                        paddingTop: 2,
                        display: "flex",
                        flexDirection: "column",
                        justifyContent: "center",
                        background: "#F9F6FF",
                        borderRadius: "24px 0px 0px 24px"
                    }, children: [_jsx(Typography, { className: "buttomheading", children: translate("I am here for you") }), _jsx(Typography, { className: "buttomtext", children: "Team Eurosafe" })] }) })] }));
};
